<p-skeleton *ngFor="let _ of [].constructor(count)" styleClass="my-4" />
